<template>
  <div class="manageCreatedActi">
    <div class="manageCreatedActi-img">
      <img src="@/assets/partyreports/top-bg-cjhd.png" alt />
    </div>
    <div class="manageCreatedActi-box">
      <div>请填写志愿服务活动相关信息</div>
      <p>
        <span style="color: red">*</span>
        活动标题
      </p>
      <el-input
        resize="none"
        type="text"
        v-model="msg.headline"
        placeholder="请输入"
      ></el-input>

      <p>
        <span style="color: red">*</span>
        活动详情描述
      </p>
      <!-- <el-input
        resize="none"
        type="textarea"
        v-model="msg.detail"
        placeholder="请输入"
      ></el-input> -->
      <Uedior :content="msg.detail" @changeHtml="changeHtml"></Uedior>

      <p>
        <span style="color: red">*</span>
        活动地点
      </p>
      <el-input
        resize="none"
        type="text"
        v-model="msg.address"
        placeholder="请输入"
      ></el-input>

      <p>
        <span style="color: red">*</span>
        活动报名开始时间
      </p>
      <div>
        <el-date-picker
          v-model="msg.reportStart"
          type="datetime"
          placeholder="请选择"
          align="right"
          @change="reportStartChange"
        >
        </el-date-picker>
      </div>

      <p>
        <span style="color: red">*</span>
        活动报名结束时间
      </p>
      <div>
        <el-date-picker
          v-model="msg.reportEnd"
          type="datetime"
          placeholder="请选择"
          align="right"
          @change="reportEndChange"
        >
        </el-date-picker>
      </div>

      <p>
        <span style="color: red">*</span>
        活动开始时间
      </p>
      <div>
        <el-date-picker
          v-model="msg.actiStart"
          type="datetime"
          placeholder="请选择"
          align="right"
          @change="actiStartChange"
        >
        </el-date-picker>
      </div>

      <p>
        <span style="color: red">*</span>
        活动结束时间
      </p>
      <div>
        <el-date-picker
          v-model="msg.actiEnd"
          type="datetime"
          placeholder="请选择"
          align="right"
          @change="actiEndChange"
        >
        </el-date-picker>
      </div>

      <p>
        <span style="color: red">*</span>
        上传活动凭证截止时间
      </p>
      <div>
        <el-date-picker
          v-model="msg.date"
          type="datetime"
          placeholder="请选择"
          align="right"
          @change="dateChange"
        >
        </el-date-picker>
      </div>

      <p>
        <span style="color: red">*</span>
        人数限制选择
      </p>
      <div class="chooseman">
        <div>
          <el-radio v-model="radio" label="0">不限人数</el-radio>
        </div>
        <div>
          <el-radio v-model="radio" label="1">限制人数</el-radio>
        </div>
        <div>
          <el-input
            v-show="radio == 1"
            resize="none"
            type="text"
            v-model="msg.num"
            placeholder="输入人数"
          ></el-input>
        </div>
      </div>

      <div class="submit" @click="submit">确认提交</div>
    </div>

    <!-- 提交成功 -->
    <el-dialog :visible.sync="submitVisible" class="dialog">
      <div class="dialog-imgbox">
        <img src="@/assets/partyreports/tc-icon.png" alt="" />
        <div class="dialog-title">
          <p>志愿服务活动创建成功!</p>
          <p>您可以在我创建的活动中查看</p>
        </div>
        <div class="buttonbox">
          <div class="Continue" @click="Continue">继续创建</div>
          <div class="button" @click="back">返回上级</div>
        </div>
      </div>
    </el-dialog>
    <!-- 修改成功 -->
    <el-dialog :visible.sync="editorVisible" class="dialog">
      <div class="dialog-imgbox">
        <img src="@/assets/partyreports/tc-icon.png" alt="" />
        <div class="dialog-title">
          <p>志愿服务活动修改成功!</p>
          <p>您可以在我创建的活动中查看</p>
        </div>
        <div class="buttonbox">
          <div style="width: 100%" class="button" @click="back">返回上级</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uedior from '@/views/component/Uedior.vue'
import { compareTime, compareTimeStan, timeToSc } from '@/utils/timecompare'

import Vue from 'vue'

export default {
  data() {
    return {
      msg: {
        headline: '',
        detail: '',
        address: '',
        reportStart: '',
        reportEnd: '',
        actiStart: '',
        actiEnd: '',
        date: '',
        num: '0',
      },
      radio: '0', //选中不限制还是限制人数
      submitVisible: false, //添加成功弹窗
      idDisabled: false, //是否为编辑
      editorVisible: false, //修改成功弹窗
      texts: { msg: '' },
      beforeNum: '',
      beforeCount: '',
      c2userid: Number(sessionStorage.getItem('c2userid') || 0),
      msg2: {}
    }
  },
  methods: {
    changeHtml(html) {
      this.msg.detail = html || ''
    },
    submit() {
      for (const key in this.msg) {
        if (this.msg[key] == '') {
          this.$message({
            message: `请填写完整`,
            type: 'error',
            offset: 300,
          })
          return
        }
      }
      if (compareTimeStan(this.msg.reportStart, this.msg.reportEnd)) {
        this.$message({
          message: '报名结束时间不能小于报名开始时间！',
          type: 'error',
          offset: 300,
        })
        return
      } else if (compareTimeStan(this.msg.actiStart, this.msg.actiEnd)) {
        this.$message({
          message: '活动结束时间不能小于活动开始时间！',
          type: 'error',
          offset: 300,
        })
        return
      } else if (compareTimeStan(this.msg.reportStart, this.msg.actiStart)) {
        this.$message({
          message: '报名开始时间不能大于活动开始时间',
          type: 'error',
          offset: 300,
        })
        return
      } else if (timeToSc(this.msg.reportStart) <= (new Date().getTime()) / 3600 / 1000) {
        this.$message({
          message: '报名开始时间不能小于当前时间！',
          type: 'error',
          offset: 300,
        })
        return
      } else if (compareTimeStan(this.msg.actiStart, this.msg.date)) {
        this.$message({
          message: '上传活动凭证日期不能小于活动开始时间！',
          type: 'error',
          offset: 300,
        })
        return
      } else if (compareTimeStan(this.msg.reportEnd, this.msg.actiStart)) {
        this.$message({
          message: '活动开始时间不能小于活动报名结束时间',
          type: 'error',
          offset: 300,
        })
        return
      }
      if (this.radio == 1 && Number(this.msg?.num || 0) <= 0) {
        this.$message({
          message: '请填写限制人数数量',
          type: 'error',
          offset: 300,
        })
        return
      }
      if (!this.idDisabled) {
        //添加活动
        const params = {
          headline: this.msg.headline,
          address: this.msg.address,
          stratRegistrationTime: this.$fun.time(this.msg.reportStart),
          endRegistrationTime: this.$fun.time(this.msg.reportEnd),
          startActivityTime: this.$fun.time(this.msg.actiStart),
          endActivityTime: this.$fun.time(this.msg.actiEnd),
          number: this.msg.num,
          memo: this.msg.detail,
          restrictionTime: this.$fun.time(this.msg.date),
          userid: this.c2userid,
        }
        this.axios
          .post('/api/ManageVolunteer/AddActivity', params)
          .then((res) => {
            for (const key in this.msg) {
              this.msg[key] = ''
            }
            this.submitVisible = true
          })
      } else {
        //编辑活动
        if (this.beforeCount > this.msg.num && this.radio == 1) {
          //如果之前选择人数大于了修改之后的人数，并且当前选择的不是无限制人数
          this.$message({
            message: '人数限制不能小于已报名的人数',
            type: 'error',
            offset: 300,
          })
          return
        }
        /* 活动报名开始后不能修改 */
        if ((new Date().getTime()) / 3600 / 1000 < timeToSc(this.msg.reportStart)) {
          this.$message({
            message: '活动报名开始后不能修改',
            type: 'error',
            offset: 300,
          })
          return
        }

        const params = {
          headline: this.msg.headline,
          address: this.msg.address,
          stratRegistrationTime: this.$fun.time(this.msg.reportStart),
          endRegistrationTime: this.$fun.time(this.msg.reportEnd),
          startActivityTime: this.$fun.time(this.msg.actiStart),
          endActivityTime: this.$fun.time(this.msg.actiEnd),
          restrictionTime: this.$fun.time(this.msg.date),
          memo: this.msg.detail,
          id: this.$route.query.id,
          number: this.msg.num,
        }
        this.axios
          .post('/api/ManageVolunteer/UpdMyActivity', params)
          .then((res) => {
            for (const key in this.msg) {
              this.msg[key] = ''
            }
            this.editorVisible = true
          })
      }
    },
    Continue() {
      this.submitVisible = false
    },
    back() {
      window.history.back(-1)
    },
    getEditor() {
      this.axios
        .get(`/api/ManageVolunteer/UpdMyActivity?id=${this.$route.query.id}`)
        .then((res) => {
          this.msg2 = res.data.msg
          this.idDisabled = true
          Vue.set(this.msg, 'headline', res.data.msg.headline)
          Vue.set(this.msg, 'detail', res.data.msg.memo)
          Vue.set(this.msg, 'address', res.data.msg.address)
          Vue.set(this.msg, 'reportStart', this.$fun.time(res.data.msg.stratRegistrationTime))
          Vue.set(this.msg, 'reportEnd', this.$fun.time(res.data.msg.endRegistrationTime))
          Vue.set(this.msg, 'actiStart', this.$fun.time(res.data.msg.startActivityTime))
          Vue.set(this.msg, 'actiEnd', this.$fun.time(res.data.msg.endActivityTime))
          Vue.set(this.msg, 'date', this.$fun.time(res.data.msg.restrictionTime))
          /* this.msg.headline = res.data.msg.headline
          this.msg.detail = res.data.msg.memo
          this.msg.address = res.data.msg.address
          this.msg.reportStart = res.data.msg.stratRegistrationTime
          this.msg.reportEnd = res.data.msg.endRegistrationTime
          this.msg.actiStart = res.data.msg.startActivityTime
          this.msg.actiEnd = res.data.msg.endActivityTime
          this.msg.date = res.data.msg.restrictionTime */
          if (res.data.msg.number == 0) {
            this.radio = '0'
            this.msg.num = res.data.msg.number
            this.beforeNum = res.data.msg.number
            this.beforeCount = res.data.count
          } else {
            this.radio = '1'
            setTimeout(() => {
              this.msg.num = res.data.msg.number
              this.beforeNum = res.data.msg.number
              this.beforeCount = res.data.count
            }, 200)
          }
        })
    },
    reportStartChange(e) {
      this.msg.reportStart = this.$fun.time(e)
    },
    reportEndChange(e) {
      this.msg.reportEnd = this.$fun.time(e)
    },
    actiStartChange(e) {
      this.msg.actiStart = this.$fun.time(e)
    },
    actiEndChange(e) {
      this.msg.actiEnd = this.$fun.time(e)
    },
    dateChange(e) {
      this.msg.date = this.$fun.time(e)
    }
  },
  created() {
    if (this.$route.query.beforePath) this.getEditor()
  },
  watch: {
    radio(val) {
      if (val == 0) {
        this.msg.num = '0'
      } else {
        this.msg.num = ''
      }
    },
    'texts.msg'(val) {
      // console.log(val);
      // if (val == "") this.msg.detail = val;
    },
  },
  components: {
    Uedior,
  },
}
</script>

<style lang="scss" scoped>
.manageCreatedActi {
  &-img {
    img {
      width: 100%;
    }
  }
  &-box {
    > div:first-child {
      font-size: 0.4rem;
      font-weight: bold;
      color: #000000;
    }
    p {
      font-size: 0.26rem;
      font-weight: 500;
      color: #666666;
      margin: 0.4rem 0 0.2rem;
    }
    .submit {
      width: 4.6rem;
      height: 0.76rem;
      background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
      box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
      border-radius: 0.08rem;
      font-weight: 500;
      color: #f6f5f8;
      line-height: 0.76rem;
      text-align: center;
      margin: 0 auto 0;
    }
    .uploadBox {
      margin: 0 0 0.55rem;
    }
    .optionsbox {
      position: relative;
    }
    .chooseman {
      div {
        margin-right: 0.5rem;
      }
      height: 0.4rem;
      align-items: center;
      display: flex;
      margin-bottom: 1rem;
    }

    width: 94%;
    left: 3%;
    padding: 0.4rem;
    padding-left: 0.2rem;
    background: #fff;
    position: absolute;
    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    top: 3.4rem;
    border-radius: 0.1rem;
  }
  .dialog {
    &-imgbox {
      img {
        width: 1.74rem;
        height: 1.74rem;
        border-radius: 50%;
      }
    }
    &-title {
      > p:nth-of-type(1) {
        font-size: 0.26rem;
        font-weight: 500;
        color: #666666;
        margin-bottom: 0.1rem;
      }
      > p:nth-of-type(2) {
        font-size: 0.3rem;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.3rem;
      }
    }
    .buttonbox {
      .Continue {
        width: 1.78rem;
        height: 0.76rem;
        border: 0.01rem solid #fd7651;
        border-radius: 0.08rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: 500;
        color: #fb7259;
        line-height: 0.76rem;
      }
      .button {
        width: 1.78rem;
        height: 0.76rem;
        background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
        border-radius: 0.08rem;
        text-align: center;
        font-size: 0.3rem;
        font-weight: 500;
        color: #f6f5f8;
        line-height: 0.76rem;
      }
      display: flex;
      justify-content: space-between;
    }

    // padding-bottom: 0.71rem;
  }
  /deep/.el-input__inner {
    background-color: #f4f4f4;
    border: none;
  }
  /deep/.el-textarea__inner {
    border: none;
    background-color: #f4f4f4;
    height: 3.15rem;
    color: #606266;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 2rem;
    height: 2rem;
    margin: 0 0.12rem 0.08rem 0;
  }
  /deep/.el-upload--picture-card {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
  }
  /deep/.el-dialog {
    width: 70%;
    text-align: center;
  }
  /deep/.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  padding: 1rem 0 0;
  font-size: 0.3rem;
}
</style>
